"use client"
import { formatDate, get, post } from '@/app/helpers';
import useFetch from '@/app/useFetch';
import React, { useState } from 'react'
import { toast } from 'react-toastify';
import { IMG_URL } from '@/app/config';
import { API_URL } from '@/app/config';

const ComplaintStatus = () => {
    const [statusNumber, setStatusNumber] = useState("")
    const [isloading, setisloading] = useState(false)
    const steps = [
        "Complaint Received",
        "Under Verification",
        "Investigation In-Progress",
        "Report Filed",
        "Closed",
    ];

    const [statusData, setStatusData] = useState(null)

    const currentStep = 3; // example: step 3 active (Investigation)

    const [num1, setNum1] = useState(() => Math.floor(Math.random() * 10) + 1);
    const [num2, setNum2] = useState(() => Math.floor(Math.random() * 10) + 1);
    const [captchaAnswer, setCaptchaAnswer] = useState("");
    const [captchaError, setCaptchaError] = useState("");
    const [phone, setPhone] = useState("");


    const resetCaptcha = () => {
        setNum1(Math.floor(Math.random() * 10) + 1);
        setNum2(Math.floor(Math.random() * 10) + 1);
        setCaptchaAnswer("");
    };

    const validateCaptcha = () => {
        if (parseInt(captchaAnswer) !== num1 + num2) {
            setCaptchaError("Incorrect CAPTCHA answer");
            resetCaptcha();
            return false;
        }
        setCaptchaError("");
        return true;
    };

    function handleCasestatus() {
        if (!statusNumber) {
            toast.error("Please enter Acknowledgement Number");
            return;
        }
        if (!phone) {
            toast.error("Please enter Mobile Number");
            return;
        }

        if (!/^[6-9]\d{9}$/.test(phone)) {
            toast.error("Enter valid 10-digit Mobile Number");
            return;
        }

        if (!validateCaptcha()) return;
        setisloading(true)
        post(`/website/tracking`, { complaint_id: statusNumber, phone: phone }).then((res) => {
            setStatusData(res.data)
        }).catch((err) => {
            toast.error(err.message)

        }).finally(() => {
            setisloading(false)
        })
    }



    const handleDownload = async () => {
        try {
            const response = await post("/website/tracking-pdf", {
                complaint_id: statusNumber,
            });

            if (response?.filename) {
                const fileName = response.filename || response.filename;

                if (!fileName) {
                    console.error("File name missing in response");
                    return;
                }

                // Build final PDF URL
                const pdfUrl = `${API_URL}website/tracking-download/${fileName}`;

                // Open PDF in new tab
                window.open(pdfUrl, "_blank");

            }

        } catch (error) {
            console.error("Error downloading PDF:", error);
        }
    };




    return (
        <>
            <section className='mt-40'>
                <div className='row'>
                    <div className='search-complaint'>
                        <div className='row'>

                            <p className='track-p'>Track your Complaint Status</p>

                            <div className="acck-div mt-40">
                                <div className="row justify-content-center g-3">

                                    {/* Acknowledgement */}
                                    <div className="col-12 col-sm-6 col-xl-3">
                                        <p>Acknowledgement No.<span>*</span></p>
                                        <input
                                            onChange={(e) => setStatusNumber(e.target.value)}
                                            placeholder="Enter Acknowledgement No.*"
                                        />
                                    </div>

                                    {/* Mobile */}
                                    <div className="col-12 col-sm-6 col-xl-3">
                                        <p>Mobile Number<span>*</span></p>
                                        <input
                                            type="tel"
                                            value={phone}
                                            maxLength={10}
                                            placeholder="Enter Mobile Number"
                                            onChange={(e) =>
                                                setPhone(e.target.value.replace(/\D/g, ""))
                                            }
                                        />
                                    </div>

                                    {/* CAPTCHA */}
                                    <div className="col-12 col-sm-6 col-xl-3">
                                        <p>
                                            What is <strong>{num1} + {num2}</strong>? <span>*</span>
                                        </p>
                                        <input
                                            type="number"
                                            value={captchaAnswer}
                                            onChange={(e) => setCaptchaAnswer(e.target.value)}
                                            placeholder="Enter CAPTCHA answer"
                                        />
                                        {captchaError && (
                                            <small className="text-danger">{captchaError}</small>
                                        )}
                                    </div>

                                    {/* Submit */}
                                    <div className="col-12 col-sm-6 col-xl-3 d-flex align-items-end">
                                        <button
                                            disabled={isloading}
                                            onClick={handleCasestatus}
                                            className="cap-sub-button w-100"
                                        >
                                            {isloading ? "Fetching..." : "Submit"}
                                        </button>
                                    </div>

                                </div>
                            </div>






                        </div>
                    </div>

                </div>
                {statusData &&
                    <div className='row mt-40'>

                        <div className='complaint-detail'>
                            <div className='row'>
                                <div className='col-lg-4 col-md-5 boder-right'>
                                    <p className='track-p'>Complaint Details</p>
                                    <p className='trap-pdetails'>Complaint Number : <span>{statusData?.complaint_id}</span></p>
                                    <p className='trap-pdetails'>Complaint/Petition Date : <span>{formatDate(statusData?.complaint_date)}</span></p>
                                    <p className='trap-pdetails'>Department : <span>{statusData?.department}</span></p>
                                    <p className='trap-pdetails'>Current Status : <span>{statusData?.current_status}</span></p>
                                    <p className='trap-pdetails'>
                                        Last Updated :
                                        <span>
                                            {statusData?.last_updated
                                                ? formatDate(statusData.last_updated)
                                                : " ---"}
                                        </span>
                                    </p>
                                </div>

                                <div className='col-lg-8 col-md-7 px-auto px-md-5 mt-4 mt-md-0'>
                                    <div className='d-flex flex-column justify-content-between h-100'>
                                        <div>
                                            <p className='track-p'>Complaint Status</p>
                                            <p className='trap-pdetails'>Remarks : <span>{statusData?.remarks}</span></p>
                                        </div>


                                        <div className="tracking-container d-none justify-content-between align-items-center">
                                            {steps.map((label, index) => {
                                                const stepNumber = index + 1;
                                                const isCompleted = stepNumber < currentStep;
                                                const isActive = stepNumber === currentStep;

                                                return (
                                                    <div key={index} className="step-wrapper d-flex flex-column align-items-center">
                                                        <div
                                                            className={`circle ${isCompleted ? "completed" : ""} ${isActive ? "active" : ""
                                                                }`}
                                                        >
                                                            {isCompleted ? "✔" : stepNumber}
                                                        </div>
                                                        {index < steps.length - 1 && (
                                                            <div
                                                                className={`linec ${stepNumber < currentStep ? "completed" : ""}`}
                                                            ></div>
                                                        )}
                                                        <p className="step-label">{label}</p>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        {/* <div className='download-div mt-40'>
                                            <p className='trap-pdetails'>For queries contact Kerala vigilance office toll free 1064</p>
                                            <button onClick={handleDownload} className='download-case'>Download Case Status</button>
                                        </div> */}

                                    </div>


                                </div>
                            </div>

                        </div>
                    </div>}


            </section>

        </>
    )
}

export default ComplaintStatus
